import { useCallback, useContext } from "react";

import { ClienteContext } from "../contexts/ClienteContext";

import AccordionClienteBodyCpf from "./AccordionClienteBodyCpf";
import AccordionClienteBodyCnpj from "./AccordionClienteBodyCnpj";

export default function AccordionClienteOutrasInfo() {
  const { generalCpfCnpj } = useContext(ClienteContext);

  const getComponent = useCallback(() => {
    const validMaskCpfCnpj = generalCpfCnpj.replace(/[^0-9]+/g, "").length;
    const validCnpj =
      validMaskCpfCnpj === 11 ? "cpf" : validMaskCpfCnpj === 14 ? "cnpj" : "";

    if (validCnpj !== "cpf" && validCnpj !== "cnpj") return null;

    const componentOptions = {
      cpf: <AccordionClienteBodyCpf />,
      cnpj: <AccordionClienteBodyCnpj />,
    };

    return componentOptions[validCnpj] || null;
  }, [generalCpfCnpj]);

  return getComponent();
}
